module.exports = __webpack_public_path__ + "static/media/more-menu.34beef7d.svg";